import {format, subDays} from 'date-fns';
import Api from 'services/Api';

export function makeQuery (params) {
  const timeFilter = {
    scope: 'req',
    type: 'range',
    dim: 'isotime',
    begin: params.from,
    end: params.to
  }

  return {
    app_id: params.appId,
    transformations: [],
    sets: [
      {
        store: 'users',
        measures: [
          {
            measure: 'nr_users',
            agg: 'sum',
            custom_id: 'value'
          }
        ],
        dimensions: [],
        filters: []
      },
      {
        store: 'users',
        measures: [
          {
            measure: 'nr_users_total',
            agg: 'sum',
            custom_id: 'value'
          }
        ],
        dimensions: [
          {
            dim: 'isotime',
            bucket: {
              format_length: 'YYYY-MM-DD'
            },
            custom_id: 'time'
          }
        ],
        filters: [
          timeFilter
        ]
      },
      {
        store: 'user_activity',
        measures: [
          {
            measure: 'nr_users',
            agg: 'count',
            custom_id: 'value'
          }
        ],
        dimensions: [],
        filters: []
      },
      {
        store: 'user_activity',
        measures: [
          {
            measure: 'nr_users',
            agg: 'count',
            custom_id: 'value'
          }
        ],
        dimensions: [
          {
            dim: 'isotime',
            bucket: {
              format_length: 'YYYY-MM-DD'
            },
            custom_id: 'time'
          }
        ],
        filters: [
          timeFilter
        ]
      },
      {
        store: 'user_tracking_status',
        measures: [
          {
            measure: 'nr_users',
            custom_id: 'value'
          }
        ],
        dimensions: [
          {
            custom_id: 'time',
            dim: 'isotime',
            bucket: {
              format_length: 'YYYY-MM-DD'
            }
          }
        ],
        filters: [
          timeFilter,
          {
            scope: 'req',
            type: 'values',
            dim: 'tracking_status',
            values: ['on']
          }
        ]
      },
      {
        store: 'user_tracking_status',
        measures: [
          {
            measure: 'nr_users',
            custom_id: 'value'
          }
        ],
        dimensions: [
          {
            custom_id: 'time',
            dim: 'isotime',
            bucket: {
              format_length: 'YYYY-MM-DD'
            }
          }
        ],
        filters: [
          timeFilter,
          {
            scope: 'req',
            type: 'values',
            dim: 'tracking_status',
            values: ['off']
          }
        ]
      }
    ]
  }
}

export const fetchSdkInstallsData = (appId, timeRange) => {
  const to = format(timeRange.to, 'YYYY-MM-DD');
  let from = format(timeRange.from, 'YYYY-MM-DD');

  if (from === to) {
    from = format(subDays(timeRange.to, 1), 'YYYY-MM-DD');
  }

  const body =
    {
      app_id: params.appId,
      transformations: [],
      sets: [
        {
          store: 'users',
          measures: [
            {
              measure: 'nr_users',
              agg: 'sum',
              custom_id: 'value'
            }
          ],
          dimensions: [],
          filters: []
        },
        {
          store: 'users',
          measures: [
            {
              measure: 'nr_users_total',
              agg: 'sum',
              custom_id: 'value'
            }
          ],
          dimensions: [
            {
              dim: 'isotime',
              bucket: {
                format_length: 'YYYY-MM-DD'
              },
              custom_id: 'time'
            }
          ],
          filters: [
            {
              scope: 'req',
              type: 'range',
              dim: 'isotime',
              begin: params.from,
              end: params.to
            }
          ]
        }
      ]
    }
  ;

  return Api.insights.query(body);
};

export const fetchUsersTrackingData = (appId, timeRange) => {
  const to = format(timeRange.to, 'YYYY-MM-DD');
  let from = format(timeRange.from, 'YYYY-MM-DD');

  if (from === to) {
    from = format(subDays(timeRange.to, 1), 'YYYY-MM-DD');
  }

  const body =
    {
      app_id: params.appId,
      transformations: [],
      sets: [
        {
          store: 'user_activity',
          measures: [
            {
              measure: 'nr_users',
              agg: 'count',
              custom_id: 'value'
            }
          ],
          dimensions: [],
          filters: []
        },
        {
          store: 'user_activity',
          measures: [
            {
              measure: 'nr_users',
              agg: 'count',
              custom_id: 'value'
            }
          ],
          dimensions: [
            {
              dim: 'isotime',
              bucket: {
                format_length: 'YYYY-MM-DD'
              },
              custom_id: 'time'
            }
          ],
          filters: [
            {
              scope: 'req',
              type: 'range',
              dim: 'isotime',
              begin: params.from,
              end: params.to
            }
          ]
        }
      ]
    }
  ;

  return Api.insights.query(body);
};

export const fetchOptedInData = (appId, timeRange) => {
  const to = format(timeRange.to, 'YYYY-MM-DD');
  let from = format(timeRange.from, 'YYYY-MM-DD');

  if (from === to) {
    from = format(subDays(timeRange.to, 1), 'YYYY-MM-DD');
  }

  const body =
    {
      app_id: params.appId,
      transformations: [],
      sets: [
        {
          store: 'user_tracking_status',
          measures: [
            {
              measure: 'nr_users',
              custom_id: 'value'
            }
          ],
          dimensions: [
            {
              custom_id: 'time',
              dim: 'isotime',
              bucket: {
                format_length: 'YYYY-MM-DD'
              }
            }
          ],
          filters: [
            {
              scope: 'req',
              type: 'range',
              dim: 'isotime',
              begin: params.from,
              end: params.to
            },
            {
              scope: 'req',
              type: 'values',
              dim: 'tracking_status',
              values: ['on']
            }
          ]
        }
      ]
    }
  ;

  return Api.insights.query(body);
};

export const fetchRevokedLocationData = (appId, timeRange) => {
  const to = format(timeRange.to, 'YYYY-MM-DD');
  let from = format(timeRange.from, 'YYYY-MM-DD');

  if (from === to) {
    from = format(subDays(timeRange.to, 1), 'YYYY-MM-DD');
  }

  const body =
    {
      app_id: params.appId,
      transformations: [],
      sets: [
        {
          store: 'user_tracking_status',
          measures: [
            {
              measure: 'nr_users',
              custom_id: 'value'
            }
          ],
          dimensions: [
            {
              custom_id: 'time',
              dim: 'isotime',
              bucket: {
                format_length: 'YYYY-MM-DD'
              }
            }
          ],
          filters: [
            {
              scope: 'req',
              type: 'range',
              dim: 'isotime',
              begin: params.from,
              end: params.to
            },
            {
              scope: 'req',
              type: 'values',
              dim: 'tracking_status',
              values: ['off']
            }
          ]
        }
      ]
    }
  ;

  return Api.insights.query(body);
};